<template>
    <div class="padding-lr-lg">
        <div class="stickyTop padding-tb-lg">
            <el-input v-model="pointKeywords" placeholder="搜索地名" clearable prefix-icon="el-icon-search" />
            <div class="flex space-between padding-top-md">
                <div class="flex gap10">
                    <el-tag v-for="item in tabOption" :key="item.value"
                        @click="changeType(item)" :effect="tabActive === item.value ? 'dark' : 'plain'">{{ item.label }}</el-tag>
                </div>
                <div><el-tag type="info" @click="changeDateBefore">{{ activeDate || '所有' }}年度</el-tag></div>
            </div>
        </div>
        <div v-for="item in computedList" :key="item.id" class="margin-bottom-lg" @click="checkItem(item)">
            <div class="font-bold margin-bottom-sm font-md">{{ item.name }}</div>
            <div class="flex padding-tb-sm" style="gap: 10px;">
                <el-tag v-for="(tItem, tIndex) in item.tags" :key="tIndex" size="mini">{{ tItem }}</el-tag>
            </div>
            <div class="line-3 font-sx">{{ item.remark }}</div>
            <div class="photo-grid padding-top-md" v-if="item.pictureList && item.pictureList.length">
                <div v-for="(mItem, mIndex) in item.pictureList" :key="mIndex" class="photo-item">
                    <img :src="mItem" />
                </div>
            </div>
            <div class="margin-top-md padding-md" style="background-color: #f1f1f1;border-radius: 3px;">
                <div class="font-sm text-darkgreyplus" v-if="item.hot">热度： 
                    <span v-for="hot in item.hot" :key="`h1${hot}`" style="color: #FFCF59;">★</span>
                    <span v-for="hot in (5 - item.hot)" :key="`h2${hot}`" style="color: #FFCF59;">☆</span>
                </div>
                <div class="margin-bottom-sm font-sm margin-top-md" v-if="item.evaluation">小编评价：{{ item.evaluation || '-' }}</div>
            </div>
            <div class="margin-top-md text-gray font-sm">{{ dateFormat(item.createTime) }}</div>
        </div>
        <div v-if="computedList.length <= 0">
            <el-empty description="竟然还没有足迹" :image-size="100"></el-empty>
        </div>
        <el-drawer title="筛选" :visible.sync="drawer" direction="btt" size="50%" :before-close="handleClose">
            <div class="padding-lr-md flex flex-warp gap10">
                <el-button v-for="item in yearOptions" :key="item.dicValue" :type="activeDate === item.dicValue ? 'primary' : ''" @click="changeDate(item)">
                    {{ item.dicLabel }}
                </el-button>
            </div>
        </el-drawer>
    </div>
</template>
<script>
    import dayjs from 'dayjs'
    export default{
		props: {
			list: {
				type: Array,
			},
            yearOptions: {
				type: Array,
			},
		},
        data(){
            return{
                drawer: false,
                activeDate: dayjs(new Date()).format('YYYY'),
                tabOption:[
					{ label: '地点', value: 'point' },
					{ label: '线路', value: 'line' },
					{ label: '项目', value: 'project' },
				],
                tabActive: 'point',
				pointKeywords: '',
                listData: [],
                defaultTypeCover01: require('@/static/image/type_cover_04.png'),
            }
        },
        computed: {
            dateFormat(){
                return (date) => {
                    return dayjs(date).format('YYYY-MM-DD hh:mm')
                }
            },
			computedList(){
				if(!this.list) return []
				return this.list.filter(item => item.name.includes(this.pointKeywords))
			},
			isHaveList(){
				if(!this.list) return []
				return this.list.filter(item => item.name.includes(this.pointKeywords)).length
			},
		},
        methods: {
            changeDateBefore(){
                this.drawer = true
            },
            handleClose(){
                this.drawer = false
                this.$emit("checkYear", this.activeDate)
            },
            changeDate(item){
                this.activeDate = item.dicValue
            },
            changeType(item){
				if(item.value !== 'point'){
					this.$message('移动端暂未开放此内容');
					return
				}
                this.tabActive = item.value
                this.$emit("checkType", item.value)
            },
			checkItem(item){
                this.$router.push(`/detail?id=${item.id}`)
			},
        }
    }
</script>
<style scoped lang="scss">
    :deep(.el-drawer__header){
        margin-bottom: 20px;
    }
    .el-button+.el-button{
        margin-left: 0;
    }
    .photo-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
    }
    .photo-item {
        position: relative;
        width: 100%;
        padding-bottom: 100%;
        overflow: hidden;
        border-radius: 0.5rem;
    }
    .photo-item img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
    }
    .line-3 {
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        word-break: break-all;
        word-wrap: break-word;
        white-space: normal !important;
        -webkit-box-orient: vertical;
    }
</style>